import { render, staticRenderFns } from "./CadastroCotistas.vue?vue&type=template&id=374b89d0&scoped=true&"
import script from "./CadastroCotistas.vue?vue&type=script&lang=js&"
export * from "./CadastroCotistas.vue?vue&type=script&lang=js&"
import style0 from "./CadastroCotistas.vue?vue&type=style&index=0&id=374b89d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b89d0",
  null
  
)

export default component.exports